import { VoucherInfo, VoucherType, Labels, PromotionSuiteVoucherStatus } from '@/types';

const getVoucherTitle = (voucherType: number, labels?: Labels) => {
	return {
		[VoucherType.OddsBooster]: labels?.lbl_RPOddsBooster,
		[VoucherType.RiskFreeBet]: labels?.lbl_RPRiskFreeBet,
		[VoucherType.CashExchange]: labels?.lbl_RPExchangeCashBack,
		[VoucherType.NicknameChange]: labels?.lbl_nickname,
		[VoucherType.FreeOddsBooster]: labels?.lbl_RPOddsBooster,
		[VoucherType.BetterCashExchange]: labels?.lbl_RPExchangeCashBack,
		[VoucherType.BestCashExchange]: labels?.lbl_RPExchangeCashBack,
		[VoucherType.NewRiskFreeBet]: labels?.lbl_RPRiskFreeBet,
		[VoucherType.AffPromotionOddsBoost]: labels?.lbl_RPOddsBooster,
		[VoucherType.StandardCashExchange]: labels?.lbl_RPExchangeCashBack,
		[VoucherType.GoodCashExchange]: labels?.lbl_RPExchangeCashBack,
		[VoucherType.GiftRiskFreeBet]: labels?.lbl_RPRiskFreeBet,
		[VoucherType.FreeBet]: labels?.lbl_FBName,
	}[voucherType] ?? '';
};

const checkVoucherStatus = (expireDate: string | Date) => {
	const endDate = new Date(expireDate);
	const currentDate = new Date(
		new Date().toLocaleString('en-US', { timeZone: 'Etc/GMT+4' })
	);
	const diffInMillis = endDate.getTime() - currentDate.getTime();
	const TEN_DAYS = 1000 * 60 * 60 * 24 * 10;
	
	return {
		isExpired: currentDate.getTime() > endDate.getTime(),
		isExpiringSoon: diffInMillis > 0 && diffInMillis < TEN_DAYS
	};
};

const isGiftVoucher = (v: VoucherInfo) => [6, 7, 11, 14, 15].includes(v.VoucherType);

const isNotYetEffective = (v: VoucherInfo) => v.VoucherStatus === PromotionSuiteVoucherStatus.NotYetEffective;

const sortByEffective = (vouchers: Array<VoucherInfo>) => {
	const effectiveVouchers = vouchers.filter(v => !isNotYetEffective(v));
	const notYetEffectiveVouchers = vouchers
		.filter(isNotYetEffective)
		.sort((a, b) => new Date(a.EffectiveDate ?? 0).getTime() - new Date(b.EffectiveDate ?? 0).getTime());

	return [...effectiveVouchers, ...notYetEffectiveVouchers];
};

export const voucherService = {
	getVoucherTitle,
	checkVoucherStatus,
	isGiftVoucher,
	isNotYetEffective,
	sortByEffective
};